import React from "react";
import {
  Checkbox as CheckboxMantine,
  CheckboxProps,
  useMantineTheme,
} from "@mantine/core";
import { HiCheck } from "react-icons/hi";

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const theme = useMantineTheme();

  return (
    <CheckboxMantine
      icon={HiCheck}
      {...props}
      sx={{
        body: { height: "28px", alignItems: "center" },
        input: {
          height: "20px",
          width: "20px",
          borderRadius: "8px",
          "&[data-checked]": {
            background: "#FFFFFF",
          },
        },
        icon: {
          height: "16px",
          width: "16px",
          background: "#FFFFFF !important",
        },
        label: {
          fontSize: "16px",
          fontWeight: 500,
          color: theme.colors.basic[5],
          paddingLeft: "8px",

          a: {
            paddingLeft: "6px",
            color: theme.colors.primary[1],
            fontWeight: 600,
            textDecoration: "underline",
          },
        },
      }}
    />
  );
};

export default Checkbox;
